import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import LoadingSpinner from "./shared/LoadingSpinner";

const RequireSuperuser = ({ children }) => {
  const { user, isInitializing } = useContext(AuthContext);
  const location = useLocation();

  // Show loading spinner while checking for cached token and fetching user data
  if (isInitializing) {
    return (
      <div style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--bg-primary, #0f172a)',
        zIndex: 2000
      }}>
        <LoadingSpinner />
      </div>
    );
  }

  // Only redirect to login after initialization is complete and no user found
  if (!user?.token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (!user?.superuser) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default RequireSuperuser;


